import styled from "styled-components";

export const TableContainer = styled.div`
  overflow-y: auto;
  /* max-height: 300px; */
  display: block;

  .table-responsive {
    height: 375px;
    overflow: auto;
    .order-details-style{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 160px;
    }
  }
  &.responsive-table {
    table {
      thead {
        tr {
          th {
            padding-block: clamp(9px, 0.625vw, 12px);
            font-size: clamp(10px, 0.729vw, 14px);
            padding-inline: clamp(12px, 0.833vw, 16px);
          }
        }
      }
      tbody {
        tr {
          td {
            padding: clamp(15px, 1.042vw, 20px) clamp(12px, 0.833vw, 16px);
            font-size: clamp(10px, 0.729vw, 14px);
          }
        }
        .status {
          border-radius: clamp(21px, 1.458vw, 28px);
          height: clamp(28px, 1.875vw, 36px);
          /* min-width: 107px; */
          font-size: clamp(10px, 0.625vw, 12px);
          letter-spacing: 0.004em;
          padding: 0 10px;
        }
      }
    }
  }
  &.dashboard-table {
    table tbody tr td {
      :first-child {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
    }
    .location-td {
      white-space: nowrap;
    }
  }
  table {
    thead {
      border-bottom: 1px solid #ececee;
      tr {
        background: #fff;
        border-style: none;
        th {
          padding-block: 12px;
          color: #000000;
          font-size: 16px;
          font-family: "latosemibold";
          padding-inline: 16px;
          background: #dcedf7;
          white-space: nowrap;
          border: none;
          position: sticky;
          top: 0;
        }
      }
    }
    tbody {
      tr {
        background: #f7f9fa;
        border: 1px solid #ececee;
        border-top: 0;
        td {
          padding: 20px;
          color: #000000;
          font-size: 14px;
          font-family: "latoregular";

          :first-child {
            font-family: "latosemibold";
          }
        }
        :nth-child(even) {
          background: #fff;
        }
      }
      .status {
        border-radius: 28px;
        height: 36px;
        /* min-width: 107px; */
        font-size: 12px;
        line-height: 17px;
        letter-spacing: 0.004em;
        border: none;
        color: black;
        background: white;
        padding: 0 10px;
        &.Pending {
          color: #f42c2c;
          background: #ffbdbd;
        }
        &.Assigned {
          background: #fceedf;
          color: #bb8347;
        }
        &.Shipped {
          background: rgba(200, 220, 250, 0.7);
          color: #5178b4;
        }
        &.Delivered {
          background: rgba(39, 174, 85, 0.1);
          color: #27ae55;
        }
        &.Completed {
          background: #27ae55;
          color: #ffffff;
        }
      }
    }
  }
`;
